import { type ReactNode } from 'react'
import { resolveCardTheme, type CardColor, type CompanyCardTheme } from '@terros/common'
import { Stack } from '@mantine/core'
import { useTranslation } from '@front/model'
import { type CompanyCardFormProps } from './CompanyCardFields'
import { ColorSwatchPicker } from './ColorSwatchPicker'

type ThemeColorField = 'bannerColor' | 'accentColor'

export const AppearanceFields = ({ form }: CompanyCardFormProps): ReactNode => {
  const { t } = useTranslation()
  const tokens = resolveCardTheme(form.values.theme)
  const bannerHint =
    tokens.ink === tokens.banner
      ? undefined
      : t('Headings on the page use a deeper shade of this color so they stay readable.')
  const accentHint =
    tokens.accentOnBanner === tokens.accent
      ? undefined
      : t('This accent is hard to read on the banner, so the rep title uses the banner text color there.')

  function updateTheme(field: ThemeColorField, color: CardColor | undefined): void {
    const updatedTheme: CompanyCardTheme = {
      ...form.values.theme,
      [field]: color,
    }
    form.setFieldValue('theme', updatedTheme)
  }

  return (
    <Stack>
      <ColorSwatchPicker
        description={bannerHint}
        label={t('Banner color')}
        value={form.values.theme?.bannerColor}
        variant='banner'
        onChange={(color) => updateTheme('bannerColor', color)}
      />
      <ColorSwatchPicker
        description={accentHint}
        label={t('Accent color')}
        value={form.values.theme?.accentColor}
        variant='accent'
        onChange={(color) => updateTheme('accentColor', color)}
      />
    </Stack>
  )
}
